<template>
  <div>
    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <v-container
        v-if="!loading && items.length"
        class="pt-10 pt-md-13 pt-lg-16 pb-0"
      >
        <TitleWidget class="text-center" small>Produtos</TitleWidget>

        <v-row class="mt-10">
          <template v-for="(item, keyItems) in items">
            <v-col :key="keyItems" cols="6" md="4">
              <PartnerProductCard v-bind="item" />
            </v-col>
          </template>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import PartnerProductCard from "../cards/PartnerProductCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "partnersProducts",
  path: "/parceiros",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    items: [],
    itemsPerPage: 100,
  }),
  created() {
    this.get();
  },
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params: {
            partner: this.itemId,
            itemsPerPage: this.itemsPerPage,
          },
        })
        .then((data) => {
          this.items = data.map(({ id, img, title }) => ({
            img,
            title,
            to: `${this.path}/${this.$route.params.item}/${formatToURL(
              title
            )}-${id}`,
          }));
        })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
    productId() {
      console.log(this.productId);
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    PartnerProductCard,
  },
};
</script>
